 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"superchart": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"superchart": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-03130e69":"2e827438","chunk-07709945":"49f2871a","chunk-075251a2":"a51a8fa4","chunk-18580d02":"f6a549f4","chunk-22d2531a":"56ffa0b9","chunk-09f3dab6":"eea4d277","chunk-62a61766":"f8e24c45","chunk-c309d536":"3cbae8f5","chunk-2f7e569c":"da1ab98e","chunk-0dcf9cb4":"458bb0d3","chunk-47621cd4":"44b96d6a","chunk-2fa5341a":"5971314a","chunk-4f5cca08":"ebee9a1c","chunk-27a592fa":"63c6db00","chunk-30888f22":"dbb44a3b","chunk-d91618ec":"05234a81","chunk-904e1042":"3fa1785c","chunk-e1774a48":"888e7904","chunk-1b0e3bc8":"b9d457d2","chunk-7377102a":"438a01a3","chunk-2992cb7a":"319d7752","chunk-38ec7434":"d3907de3","chunk-03d3ec41":"cfcbe7eb","chunk-689fa367":"33852bec","chunk-1e6e0db8":"e21e367b","chunk-2355bed6":"1f8c9143","chunk-a89bbbb0":"9ba4be93","chunk-6cf3a567":"3cd90187","chunk-7255666c":"c84c116d","chunk-7a6da654":"8e00d0f7","chunk-7b65f34e":"5ac6a278","chunk-dd190304":"be1252a5","chunk-0953a69a":"7984492a","chunk-09ed9a24":"4d55c1f2","chunk-0d942d66":"bda91962","chunk-1831e45a":"13f1cb07","chunk-1a035833":"ff754e59","chunk-2d0a30d7":"dcfc3805","chunk-2d0a3fec":"0dc00c58","chunk-2d0be2ce":"c47447e4","chunk-2d2089ab":"89fbb785","chunk-2ddbdf96":"5c91ea1e","chunk-2fcd09bb":"26108584","chunk-8ec93b78":"697dbcca","chunk-42b81087":"3d379e63","chunk-45ee3ce6":"a556925e","chunk-5a61a266":"12ca6477","chunk-5dbb621e":"c5e174a6","chunk-5f681308":"a82ff3c4","chunk-5f6d8dc1":"cd9cba52","chunk-7bcf7dd0":"413dab4e","chunk-93cc5076":"24b83a74","chunk-b13f4cbe":"33e9c936","chunk-b460c4b6":"f1f2ff7b","chunk-2d0ab81d":"22634d99","chunk-2d0b9d09":"4fe953f0","chunk-2d213ee5":"3e657cd3","chunk-2d230847":"4352cce7","chunk-b561ff06":"44b313a1","chunk-63d2117e":"3bcaa8d6","chunk-1fbb0a2c":"64710fcd","chunk-2790988a":"555b7d0a","chunk-2c02294e":"ddd49953","chunk-3674ce24":"b4ee4a8d","chunk-40b56d46":"50b8d82c","chunk-52610e30":"0ad3df43","chunk-5610e4ba":"5da74a10","chunk-9461e7aa":"891d89bb","chunk-ea60a5fc":"076e41b0","chunk-5680ac24":"5550b630","chunk-0fab145e":"89a6e7f6","chunk-25b1278c":"fd3f936b","chunk-292c82bc":"af5470a9","chunk-74d1f29c":"d8046cc6","chunk-9a0a4a96":"8ffaa872","chunk-a3dedc82":"4efdb3ab","chunk-76d0bd18":"48c87dee","chunk-3eff380a":"3a88dceb","chunk-b57eab22":"4c400088","chunk-652a35d8":"05d43b8f","chunk-2ea67f64":"58154468","chunk-48f67c08":"84041fc6","chunk-f408779c":"04e01e08","chunk-2d20e7e2":"d21d7dbd","chunk-6df900c6":"f7551560","chunk-b3b30cb6":"a75c3ddc","chunk-3a8a5a70":"3fd99489","chunk-37b4a662":"222bddad","chunk-30a9a5ce":"519e1ac9","chunk-76bde49a":"8dfa3cce","chunk-ef7abb50":"f00b0f00","chunk-5c99c189":"ff3069dd","chunk-7d0b5f1c":"7da61de4","chunk-fca9890c":"1b2972dd","chunk-20ffff47":"433f7c91","chunk-575188d7":"4eeca83c","chunk-b7d068ac":"3263b9fd","chunk-27b94f9c":"9cc92628","chunk-4a9d8bbb":"25f85659","chunk-7d057574":"cd0fe130","chunk-f732c82a":"cd76d906","chunk-f2ebc8f0":"80fd7ce1","chunk-28cf1262":"8e1d48ae","chunk-0527b227":"0cd1e014","chunk-2e5d2541":"0dddf1f4","chunk-5bbfa537":"a2061073","chunk-fb754eec":"8e708769","chunk-260e0f2c":"4067be14","chunk-31eb1765":"98ac5f54","chunk-34f20e04":"93da3e53","chunk-4f725fd1":"502e5720","chunk-c796c5d4":"3b147c05","chunk-6d34355c":"fb6314d1","chunk-2d228c16":"cf911096","chunk-42811ec0":"32437355","chunk-87f4bc60":"3afe034f","chunk-d866783c":"7a7dcb98","chunk-76cf91e6":"52cae9af","chunk-3149921a":"cca97213","chunk-3a25ec00":"193c226e","chunk-46735126":"d7b5a73a","chunk-5442403f":"8fd623b4","chunk-4612e150":"aa466073","chunk-5ace7381":"5f767b74","chunk-68d6538f":"d7800432","chunk-7793144c":"5a2b5a88","chunk-790a96f1":"d61d98d9","chunk-a3159790":"96cece8d","chunk-1b16f29c":"c4c10aed","chunk-1c828e08":"64449738","chunk-4fd8374c":"bc73717b","chunk-6bb6bffe":"f0f39e33","chunk-9e16502e":"3fdd0b78","chunk-748d1a78":"f90fccc0","chunk-37d2f537":"29d3b851","chunk-5af60c09":"013a4e56","chunk-ff5ebbd0":"b84d748e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-03130e69":1,"chunk-07709945":1,"chunk-075251a2":1,"chunk-18580d02":1,"chunk-22d2531a":1,"chunk-62a61766":1,"chunk-c309d536":1,"chunk-0dcf9cb4":1,"chunk-47621cd4":1,"chunk-27a592fa":1,"chunk-30888f22":1,"chunk-d91618ec":1,"chunk-904e1042":1,"chunk-e1774a48":1,"chunk-1b0e3bc8":1,"chunk-38ec7434":1,"chunk-03d3ec41":1,"chunk-689fa367":1,"chunk-1e6e0db8":1,"chunk-2355bed6":1,"chunk-6cf3a567":1,"chunk-7255666c":1,"chunk-7a6da654":1,"chunk-7b65f34e":1,"chunk-dd190304":1,"chunk-0953a69a":1,"chunk-09ed9a24":1,"chunk-0d942d66":1,"chunk-1831e45a":1,"chunk-1a035833":1,"chunk-2ddbdf96":1,"chunk-2fcd09bb":1,"chunk-8ec93b78":1,"chunk-42b81087":1,"chunk-5a61a266":1,"chunk-5dbb621e":1,"chunk-5f681308":1,"chunk-5f6d8dc1":1,"chunk-7bcf7dd0":1,"chunk-93cc5076":1,"chunk-b13f4cbe":1,"chunk-b460c4b6":1,"chunk-b561ff06":1,"chunk-1fbb0a2c":1,"chunk-2790988a":1,"chunk-2c02294e":1,"chunk-3674ce24":1,"chunk-40b56d46":1,"chunk-52610e30":1,"chunk-5610e4ba":1,"chunk-9461e7aa":1,"chunk-ea60a5fc":1,"chunk-5680ac24":1,"chunk-0fab145e":1,"chunk-25b1278c":1,"chunk-292c82bc":1,"chunk-74d1f29c":1,"chunk-9a0a4a96":1,"chunk-a3dedc82":1,"chunk-b57eab22":1,"chunk-6df900c6":1,"chunk-b3b30cb6":1,"chunk-3a8a5a70":1,"chunk-37b4a662":1,"chunk-30a9a5ce":1,"chunk-76bde49a":1,"chunk-ef7abb50":1,"chunk-7d0b5f1c":1,"chunk-20ffff47":1,"chunk-575188d7":1,"chunk-b7d068ac":1,"chunk-27b94f9c":1,"chunk-4a9d8bbb":1,"chunk-7d057574":1,"chunk-f732c82a":1,"chunk-f2ebc8f0":1,"chunk-0527b227":1,"chunk-2e5d2541":1,"chunk-5bbfa537":1,"chunk-fb754eec":1,"chunk-260e0f2c":1,"chunk-31eb1765":1,"chunk-34f20e04":1,"chunk-4f725fd1":1,"chunk-c796c5d4":1,"chunk-6d34355c":1,"chunk-42811ec0":1,"chunk-87f4bc60":1,"chunk-d866783c":1,"chunk-3a25ec00":1,"chunk-46735126":1,"chunk-5442403f":1,"chunk-4612e150":1,"chunk-5ace7381":1,"chunk-68d6538f":1,"chunk-7793144c":1,"chunk-790a96f1":1,"chunk-a3159790":1,"chunk-1c828e08":1,"chunk-4fd8374c":1,"chunk-6bb6bffe":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-03130e69":"814e68bb","chunk-07709945":"c979c186","chunk-075251a2":"0e433876","chunk-18580d02":"60ffef21","chunk-22d2531a":"d3c0959b","chunk-09f3dab6":"31d6cfe0","chunk-62a61766":"73cba1d2","chunk-c309d536":"06d53a06","chunk-2f7e569c":"31d6cfe0","chunk-0dcf9cb4":"b769de7b","chunk-47621cd4":"00f93cb9","chunk-2fa5341a":"31d6cfe0","chunk-4f5cca08":"31d6cfe0","chunk-27a592fa":"39530ca4","chunk-30888f22":"7aa34468","chunk-d91618ec":"e6f2c65c","chunk-904e1042":"8ec1c5ec","chunk-e1774a48":"3362c097","chunk-1b0e3bc8":"a2b49211","chunk-7377102a":"31d6cfe0","chunk-2992cb7a":"31d6cfe0","chunk-38ec7434":"2778f154","chunk-03d3ec41":"b882391a","chunk-689fa367":"017302c0","chunk-1e6e0db8":"8ee10342","chunk-2355bed6":"caf2205d","chunk-a89bbbb0":"31d6cfe0","chunk-6cf3a567":"ce1f9a3b","chunk-7255666c":"13a06cb8","chunk-7a6da654":"0e56378d","chunk-7b65f34e":"0e433876","chunk-dd190304":"420ff478","chunk-0953a69a":"a27be36c","chunk-09ed9a24":"cc9d630f","chunk-0d942d66":"1d39d689","chunk-1831e45a":"33e0086a","chunk-1a035833":"d1031e89","chunk-2d0a30d7":"31d6cfe0","chunk-2d0a3fec":"31d6cfe0","chunk-2d0be2ce":"31d6cfe0","chunk-2d2089ab":"31d6cfe0","chunk-2ddbdf96":"4a8173d2","chunk-2fcd09bb":"d854743e","chunk-8ec93b78":"05f0007f","chunk-42b81087":"feff9985","chunk-45ee3ce6":"31d6cfe0","chunk-5a61a266":"dc130592","chunk-5dbb621e":"369286fe","chunk-5f681308":"4e288fbd","chunk-5f6d8dc1":"4a916f65","chunk-7bcf7dd0":"f766de5d","chunk-93cc5076":"6dc4712f","chunk-b13f4cbe":"3e3d226c","chunk-b460c4b6":"412e0c91","chunk-2d0ab81d":"31d6cfe0","chunk-2d0b9d09":"31d6cfe0","chunk-2d213ee5":"31d6cfe0","chunk-2d230847":"31d6cfe0","chunk-b561ff06":"88a074c7","chunk-63d2117e":"31d6cfe0","chunk-1fbb0a2c":"91bc3246","chunk-2790988a":"29d9c300","chunk-2c02294e":"6183c256","chunk-3674ce24":"67cbcf92","chunk-40b56d46":"9e84695a","chunk-52610e30":"de38ed42","chunk-5610e4ba":"60eee491","chunk-9461e7aa":"65ba6dd5","chunk-ea60a5fc":"2ddfcf2d","chunk-5680ac24":"46ae31a9","chunk-0fab145e":"54c1bd55","chunk-25b1278c":"da59f0ed","chunk-292c82bc":"3669912f","chunk-74d1f29c":"836fc546","chunk-9a0a4a96":"52459204","chunk-a3dedc82":"3424fff1","chunk-76d0bd18":"31d6cfe0","chunk-3eff380a":"31d6cfe0","chunk-b57eab22":"a432b6df","chunk-652a35d8":"31d6cfe0","chunk-2ea67f64":"31d6cfe0","chunk-48f67c08":"31d6cfe0","chunk-f408779c":"31d6cfe0","chunk-2d20e7e2":"31d6cfe0","chunk-6df900c6":"236652b0","chunk-b3b30cb6":"8b8f4869","chunk-3a8a5a70":"e5365111","chunk-37b4a662":"3642d57b","chunk-30a9a5ce":"3fc5da3b","chunk-76bde49a":"dbd59cb6","chunk-ef7abb50":"bf29fac0","chunk-5c99c189":"31d6cfe0","chunk-7d0b5f1c":"6bcc295c","chunk-fca9890c":"31d6cfe0","chunk-20ffff47":"4e5d6982","chunk-575188d7":"7a7d1e0a","chunk-b7d068ac":"3c5bc340","chunk-27b94f9c":"08d8dbac","chunk-4a9d8bbb":"865ffdd4","chunk-7d057574":"aae00ad1","chunk-f732c82a":"12b6b8a4","chunk-f2ebc8f0":"eea95601","chunk-28cf1262":"31d6cfe0","chunk-0527b227":"aaf0418b","chunk-2e5d2541":"220d12ad","chunk-5bbfa537":"21428c44","chunk-fb754eec":"9b29518c","chunk-260e0f2c":"4623197a","chunk-31eb1765":"e77c15cd","chunk-34f20e04":"92b6ad05","chunk-4f725fd1":"b2106409","chunk-c796c5d4":"3dfa9117","chunk-6d34355c":"5f327693","chunk-2d228c16":"31d6cfe0","chunk-42811ec0":"99646586","chunk-87f4bc60":"c74f9986","chunk-d866783c":"8951ccc1","chunk-76cf91e6":"31d6cfe0","chunk-3149921a":"31d6cfe0","chunk-3a25ec00":"30396d31","chunk-46735126":"a1ada7e4","chunk-5442403f":"e34e5ee1","chunk-4612e150":"0fc08d4e","chunk-5ace7381":"d7d1c9b8","chunk-68d6538f":"f99ad128","chunk-7793144c":"b33e1d3d","chunk-790a96f1":"447c56ba","chunk-a3159790":"3927d935","chunk-1b16f29c":"31d6cfe0","chunk-1c828e08":"e146f179","chunk-4fd8374c":"3642d57b","chunk-6bb6bffe":"21fa4bc0","chunk-9e16502e":"31d6cfe0","chunk-748d1a78":"31d6cfe0","chunk-37d2f537":"31d6cfe0","chunk-5af60c09":"31d6cfe0","chunk-ff5ebbd0":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
